import Color from 'color';
import { lFColor, lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import {
  bgColor,
  borderColor,
  leftSidePanelMotionEase,
  logRes1,
  mobileRes2,
  topBarColor,
  topBarColor2,
} from 'pages/styles';
import styled, { keyframes } from 'styled-components';

const orange = Color('#d6a615').darken(0).toString();
const ink = '#212529';

const totalFooterSize = '63px';
const pagesFooterSize = '54px';
const mainFooterSize = `${Number(pagesFooterSize.replace('px', '')) +
  Number(totalFooterSize.replace('px', ''))}px`;
export const Container = styled.div<{ isCashGroup: boolean, $empty?: boolean }>`
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 1px;
  flex: 1;
  padding-bottom: ${({ isCashGroup, $empty }) => (
    $empty ? '0' : isCashGroup ? totalFooterSize : pagesFooterSize
  )};
  z-index: 1;
  display: flex;
  flex-direction: column;
  @media(max-width: ${logRes1}) {
    padding-bottom: ${({ isCashGroup, $empty }) => (
    $empty ? '0' : isCashGroup ? mainFooterSize : pagesFooterSize
  )};
  }
`;

export const AllCont = styled.div`
  border-radius: 3px;
  flex: 0 1;
  max-height: 100%;
  box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
  -webkit-box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
  -moz-box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
`;

export const Cont1 = styled.div`
  width: 100%;
  height: max-content;
  max-height: 100%;
  overflow: auto;
  z-index: 1;
  background: white;
  border-radius: 3px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  @media(max-width: ${logRes1}) {
    border: none;
  }
`;

/** Sticky value column — total footer amount block uses the same widths. */
const activityValueColumnWidth = '178px';
const valueTHWidth = '145px';
const detailTHWidth = 'calc(100vw - 15px)';
export const Table = styled.table<{ isCashGroup: boolean, itemCount: number }>`
  width: 100%;
  min-width: ${({ isCashGroup, itemCount }) => isCashGroup ? `calc(1023px + 60px + ${itemCount * 4}px)`
    : `calc(840px + 60px + ${itemCount * 4}px)`};
  height: max-content;
  font-weight: 100;
  color: #525252;
  table-layout: fixed;
  border-collapse: separate;
  border: none;
  border-spacing: 0;
  @media(max-width: ${mobileRes2}) {
    min-width: ${({ isCashGroup, itemCount }) => isCashGroup
    ? `calc((${detailTHWidth} - ${valueTHWidth}) + 470px + ${itemCount * 4}px)`
    : `calc(${detailTHWidth} + 390px + ${itemCount * 4}px)`};
  }
`;

export const THead = styled.thead`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const TR = styled.tr`
  z-index: 1;
`;

const tableBorderColor = borderColor;
export const TH = styled.th<{ isEmpty: boolean, isCashGroup: boolean }>`
  padding: 15px 30px;
  padding-bottom: 16px;
  text-align: right;
  background: white;
  width: ${({ isCashGroup }) => !isCashGroup ? 'calc(100% / 3.35)' : 'calc(100% / 4.55)'};
  font-weight: 500;
  z-index: 3;
  font-size: 12px;
  border-bottom: ${({ isEmpty }) => !isEmpty && `1px solid ${Color(tableBorderColor).lighten(0.6).toString()}`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ isCashGroup }) => !isCashGroup ? 'calc(100% / 2.1)' : 'calc(100% / 1.65)'};
    padding: 12px 15px;
  }
`;

export const lightPurple = Color(lFColor0).mix(Color('#ffffff'), 0.88).toString();

export const TH2 = styled(TH)`
  width: calc(100% / 1.95);
  background: ${lightPurple};
  border-bottom: ${({ isEmpty }) => !isEmpty && `1px solid ${Color(lFColor0).mix(Color('#ffffff'), 0.78).toString()}`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ isCashGroup }) => !isCashGroup ? `calc(${detailTHWidth})`
    : `calc(${detailTHWidth} - ${valueTHWidth})`};
  }
`;

export const TH3 = styled(TH)`
  width: 200px;
  @media(max-width: ${mobileRes2}) {
    width: 163px;
  }
`;

export const ActivityHeaderRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
`;

export const TH4 = styled(TH)`
  width: ${activityValueColumnWidth};
  border-left: 1px solid ${Color('lightgrey').lighten(0.065).toString()};
  position: sticky;
  right: 0;
  @media(max-width: ${mobileRes2}) {
    width: ${valueTHWidth};
  }
`;

export const ValueModeSelect = styled.select`
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23666' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 2px center;
  border: 1px solid ${Color('lightgrey').darken(0.05).toString()};
  border-radius: 4px;
  color: ${topBarColor2};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  padding: 3px 16px 3px 7px;
  cursor: pointer;
  max-width: 100%;
  &:focus {
    outline: none;
    border-color: ${lFColor0};
  }
`;

export const TH7 = styled(TH)<{ itemCount: number }>`
  width: ${({ itemCount }) => `calc(60px + ${itemCount * 4}px)`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ itemCount }) => `calc(35px + ${itemCount * 4}px)`};
  }
`;

export const TR2 = styled.tr``;

/** /logs jump-to-row blue. */
const hColor = Color(topBarColor).lighten(0.875).toString();
const hColorMessage = Color(hColor).darken(0.025).toString();
const newColor = Color(orange).lighten(1.05).toString();

export const TD = styled.td<{
  fontWeight?: number, isLast?: boolean, highlighted: number, ind: number, isNew: boolean
}>`
  padding: 28px 30px;
  text-align: right;
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  font-size: 12.5px;
  line-height: 1.7;
  overflow: visible;
  border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.6).toString()};
  border: ${({ isLast }) => isLast && 'none'};
  z-index: 1;
  background: ${({ isNew }) => isNew && newColor};
  background: ${({ highlighted, ind }) => highlighted === ind && hColor};
  border-bottom: ${({ highlighted, ind }) => (ind === highlighted - 1 || ind === highlighted) && 'none'};
  border-color: ${({ isNew }) => isNew && Color(newColor).darken(0.075).toString()};
  @media(max-width: ${mobileRes2}) {
    padding: 20px 15px;
    font-size: 11.5px;
    line-height: 1.55;
  }
`;

export const TD1 = styled(TD)`
  line-height: 1.8;
  background: ${Color(lFColor0).mix(Color('#ffffff'), 0.92).toString()};
  background: ${({ isNew }) => isNew && Color(newColor).darken(0.03).toString()};
  background: ${({ highlighted, ind }) => highlighted === ind && hColorMessage};
  border-bottom: 1px solid ${Color(lFColor0).mix(Color('#ffffff'), 0.84).toString()};
  border-color: ${({ isNew }) => isNew && Color(newColor).darken(0.125).toString()};
  border-bottom: ${({ highlighted, ind }) => (ind === highlighted - 1 || ind === highlighted) && 'none'};
  @media(max-width: ${mobileRes2}) {
    font-size: 12px;
    line-height: 1.65;
  }
`;

export const TD2 = styled(TD)`
  border-left: 1px solid ${Color('lightgrey').lighten(0.065).toString()};
  border-left-color: ${({ isNew }) => isNew && Color(newColor).darken(0.075).toString()};
  border-left-color: ${({ highlighted, ind }) => (ind === highlighted) &&
    Color(hColor).darken(0.075).toString()};
  position: sticky;
  right: 0; 
  background: white;
  background: ${({ isNew }) => isNew && newColor};
  background: ${({ highlighted, ind }) => highlighted === ind && hColor};
`;

export const RelCont = styled.div`
  position: relative;
  width: 100%;
`;

export const TD3 = styled(TD)`
  font-size: 11.5px;
  font-weight: 300;
`;

export const TD3Entry = styled.div`
  width: max-content;
  padding: 23px 30px;
  padding-left: 0px;
  width: 100%;
  margin: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const cashColor = Color('#40b017').darken(0.25).toString();
export const redColor = '#eb364b';

export const RestoreBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 5px 10px;
  border: none;
  border-radius: 7px;
  background: ${Color(cashColor).alpha(0.12).toString()};
  color: ${cashColor};
  font-size: 11px;
  font-weight: 600;
  font-family: inherit;
  line-height: 1;
  cursor: pointer;
  vertical-align: middle;
  transition: background 120ms ease;
  &:hover {
    background: ${Color(cashColor).alpha(0.2).toString()};
  }
  svg {
    font-size: 14px !important;
  }
`;

export const CloseReportBtn = styled(RestoreBtn)`
  background: ${Color(redColor).alpha(0.1).toString()};
  color: ${redColor};
  &:hover {
    background: ${Color(redColor).alpha(0.18).toString()};
  }
`;

/** Inline with message text — sits at end of the details line. */
export const RestoreActions = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  vertical-align: middle;
`;

const filedPreviewIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/** Expandable report body under a Report filed log row. */
export const FiledReportPreviewBox = styled.div`
  display: block;
  width: 100%;
  max-width: 520px;
  margin: 8px 0 4px;
  padding: 12px 14px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid ${Color(lFColor0).alpha(0.22).toString()};
  background: ${Color(lFColor0).alpha(0.05).toString()};
  animation: ${filedPreviewIn} 220ms ${leftSidePanelMotionEase};
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const FiledReportPreviewEmpty = styled.div`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
`;

export const FiledReportPreviewPicture = styled.div`
  margin-top: 8px;
  img {
    display: block;
    max-width: 100%;
    border-radius: 8px;
  }
`;

export const PreviewReportBtn = styled(RestoreBtn)`
  background: ${Color(lFColor0).alpha(0.12).toString()};
  color: ${lFColor0};
  &:hover {
    background: ${Color(lFColor0).alpha(0.2).toString()};
  }
`;

/** Value (or date when value is hidden) + lock icon to pin start/end logs. */
export const LockBesideCell = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
  text-align: right;
`;

/** Combined SKU details only — 3 lines, then ellipsis. Matches other /logs cells. */
export const CombinedSkuDetails = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
  text-align: right;
  overflow-wrap: anywhere;
`;

/** Soft purple chip matching Username / details-cell theme (not a white card). */
export const RestoreToggle = styled.button<{ $open?: boolean }>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: ${({ $open }) => ($open
    ? Color(lFColor0).alpha(0.2).toString()
    : Color(lFColor0).alpha(0.1).toString())};
  color: ${({ $open }) => ($open ? lFColor : Color(lFColor).alpha(0.72).toString())};
  cursor: pointer;
  vertical-align: middle;
  transition: background 120ms ease, color 120ms ease;

  &:hover {
    background: ${Color(lFColor0).alpha(0.22).toString()};
    color: ${lFColor};
  }
`;

/** Clickable "activity" token inside deleted / restored / change messages (&L&uuid&L&). */
export const ActivityIdLink = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  color: ${Color(topBarColor).darken(0.08).toString()};
  cursor: pointer;
  vertical-align: baseline;

  &:hover {
    color: ${Color(topBarColor).darken(0.22).toString()};
  }
`;

/** Clickable "restored" on post-restore Activity deleted rows (&R&uuid&R&) — no underline. */
export const RestoredIdLink = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  color: ${cashColor};
  cursor: pointer;
  vertical-align: baseline;

  &:hover {
    color: ${Color(cashColor).darken(0.12).toString()};
  }
`;

export const CashIn = styled.div`
  color: ${cashColor};
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.75px;
  display: inline-block;
  position: absolute;
  bottom: 50%;
  right: 30px;
  transform: translateY(50%);
  padding: 5px 10px;
  padding-right: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  border-radius: 3px;
  width: max-content;
  margin-left: auto;
  @media(max-width: ${mobileRes2}) {
    font-size: 13px;
    max-width: calc(100% - 20px);
    right: 15px;
  }
  &:hover {
    text-overflow: clip;
    white-space: normal;
    overflow: visible;
    background: inherit;
    word-break: break-all;
    max-width: none;
    width: max-content;
  }
`;

export const CashOut = styled(CashIn)`
  color: ${redColor};
`;

/** Units column entries + page sums — matches Total ($neutral) color. */
export const UnitsEntry = styled(CashIn)`
  color: ${topBarColor2};
  font-weight: 800;
  font-size: 14.5px;
  letter-spacing: 0.4px;
  @media(max-width: ${mobileRes2}) {
    font-size: 14px;
  }
`;

export const MoreCont = styled.div`
  color: ${Color('grey').lighten(0.5).toString()};
  position: absolute;
  right: 5px;
  bottom: 50%;
  width: max-content;
  height: max-content;
  overflow: visible;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media(max-width: ${mobileRes2}) {
    right: 1px;
  }
`;

/** Same purple as the room name chip. */
const roomAccent = Color(lFColor).lighten(0.6).toString();
/** Guest photo ring: muted green, distinct from staff (no ring) and room purple. */
const customerPhotoRing = Color('#40b017').lighten(0.18).alpha(0.8).toString();

export const Username = styled.span<{ isRemoved?: boolean }>`
  padding: 0;
  margin: 0;
  border: none;
  transform: translateY(-1px);
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: max-content;
  font-weight: 600;
  margin: 0px 2px;
  font-size: 11px;
  color: ${({ isRemoved }) => (
    isRemoved ? Color(topBarColor2).alpha(0.45).toString() : topBarColor2
  )};
  line-height: 1.2;
  vertical-align: middle;
  @media(max-width: ${mobileRes2}) {
    font-size: 10.5px;
  }
`;

/** Guest chip: black-based name, distinct from staff blue. */
export const Customer = styled(Username)`
  color: ${({ isRemoved }) => (
    isRemoved ? Color(ink).alpha(0.45).toString() : ink
  )};
`;

export const UsernamePhoto = styled.img<{ $ring?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #eef1f4;
  cursor: zoom-in;
  box-sizing: border-box;
  ${({ $ring }) => $ring && `
    border: 1.5px solid ${customerPhotoRing};
  `}
`;

export const PhotoPreviewPopup = styled.div`
  position: fixed;
  z-index: 1400;
  width: 112px;
  height: 112px;
  padding: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
`;

export const PhotoPreviewImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #eef1f4;
`;

export const UsernamePhotoFallback = styled.span<{ isRemoved?: boolean; $ring?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: ${({ isRemoved }) => (
    isRemoved
      ? Color(lFColor0).alpha(0.08).toString()
      : Color(lFColor0).alpha(0.14).toString()
  )};
  color: ${({ isRemoved }) => (
    isRemoved ? Color(lFColor).alpha(0.45).toString() : lFColor
  )};
  ${({ $ring }) => $ring && `
    border: 2px solid ${customerPhotoRing};
  `}

  & > svg {
    width: 17.5px;
    height: 17.5px;
  }
`;

/** Horizontal strip of form-photo chips inside a log description. */
export const LogPhotoScroll = styled.span`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  max-width: min(280px, 100%);
  overflow-x: auto;
  vertical-align: middle;
  padding: 2px 0;
  margin: 0 2px;
  -webkit-overflow-scrolling: touch;
`;

export const LogPhotoChip = styled.button`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 0 0 auto;
  border: 1px solid ${Color('#94a3b8').alpha(0.35).toString()};
  background: #fff;
  border-radius: 8px;
  padding: 4px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease;
  &:hover:not(:disabled) {
    border-color: ${lFColor0};
    transform: translateY(-1px);
    box-shadow: 0 2px 6px ${Color('#0f172a').alpha(0.08).toString()};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

export const LogPhotoThumb = styled.img`
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 6px;
  display: block;
  background: ${Color('#94a3b8').alpha(0.12).toString()};
`;

export const LogPhotoChipLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.2;
  max-width: 52px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LogPhotoMissing = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  font-size: 11px;
  color: #94a3b8;
`;

export const UsernameText = styled.span<{ isRemoved?: boolean }>`
  display: inline-block;
  transform: translateY(1.5px);
  text-decoration: ${({ isRemoved }) => (isRemoved ? 'line-through' : 'none')};
  text-decoration-thickness: 1px;
`;

export const Bold = styled.span`
  font-weight: 600;
  color: ${Color('#525252').darken(0.15).toString()};
`;

/**
 * Status wrap badges — asset condition (New/Good/Fair/Poor) + restored/deleted
 * + Compliance standing terms (favorable / note / incident / alert).
 * Four hues only (blue / green / amber / red); shades live here with cashColor/redColor.
 * Neutral note reuses blue (new) so we stay on those four hues.
 */
const statusNewInk = Color(lFColor).darken(0.12).toString();
const statusNewBg = Color(lFColor).alpha(0.12).toString();
const statusFairInk = Color(orange).darken(0.18).toString();
const statusFairBg = Color(orange).alpha(0.14).toString();

export type LogStatusBadgeTone = 'new' | 'good' | 'fair' | 'poor' | 'restored' | 'alert';

/** Normalize legacy Low-level * wording to Compliance * for badge display. */
export const complianceStandingDisplayLabel = (raw: string): string | null => {
  const key = String(raw || '').trim().toLowerCase();
  if (
    key === 'compliance favorable'
    || key === 'low-level favorable'
    || key === 'favorable'
  ) return 'Compliance favorable';
  if (
    key === 'compliance note'
    || key === 'low-level note'
  ) return 'Compliance note';
  if (
    key === 'compliance incident'
    || key === 'low-level incident'
    || key === 'low-level problem'
  ) return 'Compliance incident';
  if (
    key === 'compliance alert'
    || key === 'low-level alert'
  ) return 'Compliance alert';
  return null;
};

export const statusBadgeToneForText = (raw: string): LogStatusBadgeTone => {
  const key = String(raw || '').trim().toLowerCase();
  const compliance = complianceStandingDisplayLabel(raw);
  if (compliance === 'Compliance favorable') return 'good';
  if (compliance === 'Compliance note') return 'new';
  if (compliance === 'Compliance incident') return 'fair';
  if (compliance === 'Compliance alert') return 'alert';
  if (key === 'new') return 'new';
  if (key === 'good') return 'good';
  if (key === 'restored') return 'restored';
  if (key === 'fair') return 'fair';
  if (key === 'poor' || key === 'deleted' || key === 'revoked' || key === 'removed') return 'poor';
  return 'alert';
};

const statusBadgeColors = (tone: LogStatusBadgeTone): { ink: string, bg: string } => {
  if (tone === 'new') return { ink: statusNewInk, bg: statusNewBg };
  if (tone === 'good' || tone === 'restored') {
    return { ink: cashColor, bg: Color(cashColor).alpha(0.12).toString() };
  }
  if (tone === 'fair') return { ink: statusFairInk, bg: statusFairBg };
  return { ink: redColor, bg: Color(redColor).alpha(0.1).toString() };
};

export const StatusBadge = styled.span<{ $tone: LogStatusBadgeTone }>`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0 1px;
  padding: 1px 7px;
  border-radius: 5px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.35;
  color: ${({ $tone }) => statusBadgeColors($tone).ink};
  background: ${({ $tone }) => statusBadgeColors($tone).bg};
`;

/** Action-column badge for Compliance standing log types. */
export const ComplianceStandingTypeBadge = styled(StatusBadge)`
  margin: 0;
  font-size: 11px;
  padding: 2px 8px;
`;

/** Amount inside log descriptions — currency + green (in) / red (out). */
export const PriceAmount = styled.span<{ $negative?: boolean }>`
  font-weight: 700;
  color: ${({ $negative }) => ($negative ? redColor : cashColor)};
  white-space: nowrap;
`;

export const StockArrow = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: -2px;
  margin: 0 1px;
  color: ${Color('#525252').darken(0.05).toString()};
  line-height: 0;

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

export const OTA = styled.span<{ $accent?: string; $darkText?: boolean }>`
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: ${({ $darkText }) => ($darkText ? '#1a1a1a' : 'white')};
  padding: 0px 4px;
  padding-bottom: 0px;
  padding-left: 0px;
  white-space: nowrap;
  background: ${({ $accent }) => (
    $accent || Color(topBarColor2).lighten(0.4).toString()
  )};
  font-size: 11px;
  border-radius: 3px;
  gap: 4px;
  width: max-content;
  margin-top: -3px;
  transform: translateY(5px);

  .MuiSvgIcon-root {
    transform: translateY(0);
  }
`;

export const Room = styled(Username)`
  padding: 0px 0px;
  font-weight: 600;
  padding-left: 0px;
  transform: translateY(-0.5px);
  border: none;
  background: none;
  color: ${roomAccent};
  letter-spacing: 0.25px;
  z-index: 1;
`;

export const RoomText = styled.div`
  transform: translateY(0px);
`;

/** Department name — same inline treatment as room, slightly deeper purple. */
export const External = styled(Room)`
  padding: 0;
  background: none;
  color: ${Color(lFColor).lighten(0.3).toString()};
`;

export const ExternalText = styled.div`
  transform: translateY(0px);
`;

export const TFoot = styled.div<{ isCashGroup: boolean }>`
  height: ${({ isCashGroup }) => isCashGroup ? totalFooterSize : pagesFooterSize};
  position: sticky;
  right: 0;
  bottom: ${({ isCashGroup }) => isCashGroup ? `-${totalFooterSize}` : `-${pagesFooterSize}`};
  width: 100%;
  background: white;
  border-radius: 3px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  @media(max-width: ${logRes1}) {
    border-left: none;
    height: ${({ isCashGroup }) => (isCashGroup ? mainFooterSize : pagesFooterSize)};
    bottom: ${({ isCashGroup }) => (isCashGroup
    ? `-${mainFooterSize}`
    : `-${pagesFooterSize}`)};
  }
`;

export const TotalFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-top: 1px solid ${Color(tableBorderColor).lighten(0.3).toString()};
`;

export const TotalCont = styled.div<{ $withTotal?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: ${({ $withTotal }) => ($withTotal ? totalFooterSize : pagesFooterSize)};
  margin-left: auto;
  padding-left: 12px;
  @media(max-width: ${logRes1}) {
    ${({ $withTotal }) => ($withTotal ? `
      order: -1;
      width: 100%;
      justify-content: flex-end;
      box-sizing: border-box;
      padding-left: 12px;
      border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.75).toString()};
    ` : `
      margin-right: 30px;
    `)}
  }
  @media(max-width: ${mobileRes2}) {
    ${({ $withTotal }) => ($withTotal ? '' : 'margin-right: 10px;')}
  }
`;

export const TotalCont1 = styled.div`
  height: 100%;
  /* Grow with the figure; stay at least as wide as the Value column. */
  min-width: ${activityValueColumnWidth};
  width: max-content;
  box-sizing: border-box;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  @media(max-width: ${mobileRes2}) {
    min-width: ${valueTHWidth};
    padding: 0 15px;
  }
`;

export const Total = styled.div<{ isNegative: boolean; $neutral?: boolean }>`
  color: ${({ isNegative, $neutral }) => (
    $neutral ? topBarColor2 : isNegative ? redColor : cashColor
  )};
  font-weight: 700;
  font-size: 21px;
  letter-spacing: 0.35px;
  margin-left: auto;
  white-space: nowrap;
`;

const reportBannerIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/** Temporary staff-report other-party visibility while Show logs jump is active. */
export const ReportViewAsBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${Color(lFColor0).alpha(0.35).toString()};
  background: ${Color(lFColor0).alpha(0.08).toString()};
  font-size: 12.5px;
  line-height: 1.4;
  color: #2a3038;
  box-sizing: border-box;
  animation: ${reportBannerIn} 280ms ${leftSidePanelMotionEase};
  flex: 1 1 100%;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ReportViewAsExit = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: ${lFColor0};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  padding: 2px 4px;
  &:hover {
    text-decoration: underline;
  }
`;

export const ReportViewAsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const PaginationCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 30px;
  margin-right: auto;
  height: ${pagesFooterSize};
  @media(max-width: ${logRes1}) {
    flex: 1 1 100%;
    justify-content: flex-end;
    margin-left: 0;
    margin-right: 30px;
  }
  @media(max-width: ${mobileRes2}) {
    margin-right: 10px;
  }
`;

const activityLogLockChipIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const activityLogLockChipOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(8px);
  }
`;

/** Footer control: activity-log lock is on; click unlocks start/end logs. */
export const ActivityLogLockChip = styled.button<{ $leaving?: boolean }>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: min(280px, calc(100vw - 48px));
  margin: 0;
  padding: 6px 10px;
  border: 1px solid ${Color(lFColor0).alpha(0.35).toString()};
  border-radius: 8px;
  background: ${Color(lFColor0).alpha(0.08).toString()};
  color: ${lFColor0};
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  flex-shrink: 1;
  animation: ${({ $leaving }) => (
    $leaving ? activityLogLockChipOut : activityLogLockChipIn
  )} 220ms ${leftSidePanelMotionEase};
  animation-fill-mode: both;
  transition: background 160ms ease, border-color 160ms ease;

  &:hover {
    background: ${Color(lFColor0).alpha(0.14).toString()};
    border-color: ${Color(lFColor0).alpha(0.5).toString()};
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ActivityLogLockChipText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const emptyIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  pointer-events: none;
`;

export const InfoCont = styled.div`
  margin-bottom: 0px;
  width: max-content;
  max-width: 400px;
  background: transparent;
  padding: 10px 40px;
  padding-bottom: 40px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  animation: ${emptyIn} 280ms ${leftSidePanelMotionEase};
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const EmptyIconWrapper = styled.div<{ $prompt?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: ${({ $prompt }) => ($prompt
    ? Color(lFColor0).alpha(0.1).toString()
    : Color(bgColor).darken(0.03).toString())};
  color: ${({ $prompt }) => ($prompt
    ? Color(lFColor0).alpha(0.7).toString()
    : Color('#525252').lighten(0.5).toString())};
  margin-bottom: 8px;
`;

export const EmptyShowAllBtn = styled.button`
  pointer-events: auto;
  margin-top: 4px;
  border: none;
  background: ${lFColor};
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ${leftSidePanelMotionEase};
  &:hover {
    background: ${lFColor0};
  }
  &:active {
    transform: translateY(1px);
  }
  @media (prefers-reduced-motion: reduce) {
    transition: background 120ms ease;
    &:active {
      transform: none;
    }
  }
`;

export const NoResults = styled.div`
  font-size: 22px;
  margin: 0;
  width: max-content;
  max-width: 100%;
  font-weight: 600;
  color: ${Color('#525252').darken(0.1).toString()};
  text-align: center;
  line-height: 1.3;
`;

export const Info = styled.div`
  font-size: 15px;
  color: ${Color('#525252').lighten(0.2).toString()};
  width: 100%;
  text-align: center;
  margin-top: 0;
  line-height: 1.4;
  max-width: 320px;
`;
